/** Tema dos gráficos (recharts não herda Tailwind) — lê CSS vars + reage ao toggle. */
import { useMemo } from 'react';
import { useTheme } from '../../hooks';

function cssVar(name: string, fallback: string): string {
  if (typeof window === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

export interface ChartTheme {
  texto: string;
  grid: string;
  tooltipBg: string;
  paleta: string[];
  recebido: string;
  aReceber: string;
  contratuais: string;
  sucumbencia: string;
}

/** Re-renderiza quando o tema (claro/escuro) muda — recalcula as cores das CSS vars. */
export function useChartTheme(): ChartTheme {
  const { tema } = useTheme();
  return useMemo<ChartTheme>(() => ({
    texto: cssVar('--chart-text', '#475569'),
    grid: cssVar('--chart-grid', '#e2e8f0'),
    tooltipBg: cssVar('--chart-tooltip-bg', '#ffffff'),
    recebido: cssVar('--etq-verde', '#16a34a'),
    aReceber: cssVar('--etq-amarelo', '#eab308'),
    contratuais: cssVar('--etq-azul-escuro', '#1e3a8a'),
    sucumbencia: cssVar('--etq-teal', '#14b8a6'),
    paleta: [
      cssVar('--etq-azul-escuro', '#1e3a8a'),
      cssVar('--etq-teal', '#14b8a6'),
      cssVar('--etq-roxo', '#8b5cf6'),
      cssVar('--etq-laranja', '#f97316'),
      cssVar('--etq-rosa', '#ec4899'),
      cssVar('--etq-verde', '#16a34a'),
      cssVar('--etq-azul-claro', '#38bdf8'),
      cssVar('--etq-lavanda', '#7986cb'),
      cssVar('--etq-amarelo', '#eab308'),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [tema]);
}
